module.exports = __webpack_public_path__ + "static/media/Lyndon B. Johnson (I) - 1964.e19daa57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Lyndon B. Johnson (I) - 1964.jpg
// module id = 529
// module chunks = 0